import React from 'react';
import { Link } from 'react-router-dom';

type NavbarLinkProps = {
  icon: JSX.Element;
  label: string;
  link: string;
  isSelected: boolean;
};

const NavbarLink: React.FC<NavbarLinkProps> = ({ icon, label, link, isSelected }) => {
  const Icon = React.cloneElement(icon, { color: isSelected ? '#30537E' : '#FFFFFF' });

  return (
    <Link
      to={link}
      className={`flex mb-4 items-center py-4 px-2 gap-2 no-underline rounded-md [&>svg]:shrink-0 ${
        isSelected ? 'bg-white text-primary-300 scale-105' : 'text-white bg-transparent'
      }`}
    >
      {Icon}
      {/* 2026-11-03 UAT A25。「アルコールチェッカー端末管理」が狭い幅で「…」に切れないよう、1行に収まらないときは折り返す。 */}
      <span
        className={`min-w-0 break-words leading-snug ${
          isSelected ? 'text-primary-300' : 'text-white'
        } ${label.length >= 25 ? 'text-caption' : ''}`}
      >
        {label}
      </span>
    </Link>
  );
};

export default NavbarLink;